import {gsap} from "../LibrariesImport";

export default class BlockCta {

    static init() {
        const blocks = document.querySelectorAll(".block-cta");
        blocks.forEach(block => {
            this.animateBlock(block);
            this.bigA(block);
            this.animateBtn(block);
        });
    }

    static animateBlock(block) {
        const circles = block.querySelectorAll(".circle-container");

        const getRandomFloat = (min, max) => {
            return Math.random() * (max - min) + min;
        };

        circles.forEach((item) => {
            const circle = item.querySelector(".circle");

            gsap.to(item, {
                scale: 1,
                y: 0,
                opacity: 1,
                scrollTrigger: {
                    trigger: block,
                    start: "clamp(top bottom)",
                    end: "clamp(center center)",
                    scrub: 1
                }
            });

            gsap.to(circle, {
                y: "+=10%",
                duration: getRandomFloat(1.5, 2),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });

            gsap.to(circle, {
                x: "+=5%",
                duration: getRandomFloat(1.5, 2),
                repeat: -1,
                yoyo: true,
                ease: "power1.inOut",
                // Décalage aléatoire pour chaque élément
                delay: getRandomFloat(1.5, 2)
            });
        });
    }

    static bigA(block) {
        const container = block.querySelector(".big-a");
        const a = container.querySelector("img");

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: block,
                start: "top 90%",
                end: "center 75%",
                scrub: 1
            }
        });
        tl.addLabel("start");
        tl.to(a, { scale: 1, y: 0, opacity: 1, ease: "power2.in" }, "start" );

        const initMouseAnimation = (block) => {
            const container = block.querySelector(".big-a");

            if (!container) return;

            const moveX = gsap.quickTo(container, "x", {duration: 0.6, ease: "power1.out"});
            const moveY = gsap.quickTo(container, "y", {duration: 0.6, ease: "power1.out"});

            // Variables pour stocker les valeurs
            let xTo = 0;
            let yTo = 0;

            const handleMouseMove = (e) => {
                // Récupération des dimensions et position du block parent
                const rect = block.getBoundingClientRect();

                // Calcul de la position relative de la souris par rapport au block
                const mouseX = ((e.clientX - rect.left) / rect.width) - 0.5;
                const mouseY = ((e.clientY - rect.top) / rect.height) - 0.5;

                // Configuration des amplitudes
                const moveAmplitude = 70;

                // Calcul des nouvelles positions et rotations
                xTo = mouseX * moveAmplitude;
                yTo = mouseY * moveAmplitude;

                moveX(xTo);
                moveY(yTo);
            };

            const handleMouseLeave = () => {
                moveX(0);
                moveY(0);
            };

            if (!('ontouchstart' in window)) {
                block.addEventListener('mousemove', handleMouseMove);
                block.addEventListener('mouseleave', handleMouseLeave);
            }

            return () => {
                block.removeEventListener('mousemove', handleMouseMove);
                block.removeEventListener('mouseleave', handleMouseLeave);
            };
        };

        initMouseAnimation(block);
    }

    static animateBtn(block) {
        const btn = block.querySelector(".btn-magnet-cta");

        if (!btn) return;

        const label = btn.querySelector(".label");

        if (!label) return;

        label.innerHTML = `${label.textContent} `.repeat(3);

        gsap.set(label, {
            display: "inline-block",
            whiteSpace: "nowrap"
        });

        const tl = gsap.timeline({
            paused: true,
            repeat: -1,
            defaults: {
                ease: "none"
            }
        });

        // Calcule la largeur d'un texte pour savoir de combien décaler
        const textWidth = label.offsetWidth / 3;

        tl.to(label, {
            x: -textWidth,
            duration: 2,
        });

        btn.addEventListener('mouseenter', () => {
            // Remet à zéro et joue
            tl.restart();
        });

        btn.addEventListener('mouseleave', () => {
            // Retour à la position initiale en douceur
            tl.pause();
            gsap.to(label, {
                x: 0,
                duration: 0.4,
                ease: "power2.out"
            });
        });
    }
}